"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flags = exports.setTestMode = void 0;
const react_1 = __importDefault(require("react"));
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
// Test Mode:
// For now, in integration tests, all flags will always be on.
// It is set via an injected ENV var that gets read at the bottom of Root.js
let testMode = false;
function setTestMode(bool) {
    testMode = bool;
}
exports.setTestMode = setTestMode;
// All flags (both concrete flags in LaunchDarkly and computedFlags) should
// be defined here.
const Flags = {
    testFlag: 'testFlag',
    shippingReport: 'shippingReport',
    displayReports: 'displayReports',
    trackingPageManager: 'trackingPageManager',
    installableApps: 'installableApps',
    metabaseReports: 'metabaseReports'
};
exports.Flags = Flags;
// Some front end features may require one or more flags. For example, the
// "Reports" tab in the navigation bar should show if there are one or more
// reports that are viewable by the current user. So, if we add a hypothetical "Order Report",
// we would want it to show if EITHER shippingReport OR orderReport are true.
// LaunchDarkly is not terribly well suited to that sort of conditional logic
// (it's possible, but not pretty), so instead, we as developers can create
// computedFlags to abstract away that concern.
const computedFlags = {
    displayReports: (flags) => {
        return flags.shippingReport;
    }
};
// The flagsOverride and computedFlagsOverride are here for testing purposes
const withFlags = (Component, flagsOverride = launchdarkly_react_client_sdk_1.useFlags, computedFlagsOverride = computedFlags) => {
    const WrappedWithFlags = (props) => {
        const LDConsumerComponent = (0, launchdarkly_react_client_sdk_1.withLDConsumer)()(Component);
        const flags = flagsOverride();
        function hasFlag(flagName) {
            if (testMode) {
                return true;
            }
            // Object.getOwnPropertyDescriptor checks to see if a property exists on
            // an object and returns undefined if not. It is preferred over using the
            // prototype function e.g. flags.hasOwnProperty(flagName). See
            // https://ourcodeworld.com/articles/read/1425/how-to-fix-eslint-error-do-not-access-objectprototype-method-hasownproperty-from-target-object-no-prototype-builtins
            if (Object.getOwnPropertyDescriptor(flags, flagName)) {
                return flags[flagName];
            }
            if (Object.getOwnPropertyDescriptor(computedFlagsOverride, flagName)) {
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                return computedFlagsOverride[flagName](flags);
            }
            // eslint-disable-next-line no-console
            console.error('Unknown flag: ', flagName);
            return false;
        }
        return react_1.default.createElement(LDConsumerComponent, Object.assign({ hasFlag: hasFlag }, props));
    };
    return WrappedWithFlags;
};
exports.default = withFlags;
